const getFormTitle = (editMode = false, packageName) => {
  if (!editMode) {
    return "Create New Package";
  }
  return `Edit Package - ${packageName}`;
};

export { getFormTitle };
